import { queryOptions } from '@tanstack/react-query'
import qs from 'query-string'

import { API_URL } from '@/libs/configs/constant'

import { kyApi } from '@/features/api/ky'

/**
 * Utility function to generate a query options object for fetching data from an API endpoint.
 */
/**@deprecated */
export function createApiQuery<TInput = unknown, TOutput = unknown>(
	url: string
) {
	const apiFn = async (params: TInput) => {
		const searchParams = qs.stringify(params as object)
		const res = await kyApi(`${API_URL}${url || ''}`, { searchParams }).json<
			TResSuccess<TOutput>
		>()
		return res.data
	}

	return {
		/** API function to fetch data */
		api: (params: TInput): Promise<TOutput> => apiFn(params),

		/** Query options for react-query */
		qry: (params: TInput) => {
			return queryOptions({
				queryKey: [url, { params }],
				queryFn: () => apiFn(params),
			})
		},
		/** Type inference helpers */
		infer: {
			input: {} as TInput,
			output: {} as TOutput,
		},
	}
}

type MutationMethod = 'post' | 'put' | 'delete'

/**
 * Utility function to create a mutation handler for API calls.
 */
/**@deprecated */
export function createApiMutation<TInput extends {}, TOutput>(
	url: string,
	method: MutationMethod
) {
	// const apiFn = async (params: TInput): Promise<TOutput> => {
	// 	const res = await apiClient[method](endpoint, params)
	// 	return res.data.data
	// }
	const apiFn = async (params: TInput): Promise<TOutput> => {
		const res = await kyApi[method](`${API_URL}${url || ''}`, { json: params })
		return (await res.json<TResSuccess<TOutput>>()).data
	}

	return {
		/** API function to mutate data */
		api: (params: TInput): Promise<TOutput> => apiFn(params),

		/** Type inference helpers */
		infer: {
			input: {} as TInput,
			output: {} as TOutput,
		},
	}
}

/**
 * Type helpers for inferring input and output types from createApiQuery
 */
export type InferInput<T> = T extends { infer: { input: infer I } } ? I : never
export type InferOutput<T> = T extends { infer: { output: infer O } }
	? O
	: never
